import React, { createContext, useContext, useReducer } from 'react';
import { fetchHandlers, fetchInitialState, fetchReducer } from '../reducers/FetchReducer';
import { ParentContext } from './ParentContext';

/** AppContext */
export const FetchContext = createContext();

/** Global OtherDatas for the Event */
const FetchProvider = (props) => {

  const parentContext = useContext(ParentContext);
  const { fn_cls } = parentContext ?? {}

  const fetch_initState = { fn_cls }
  const [fetch_state, fetch_dispatch] = useReducer(fetchReducer, fetchInitialState(fetch_initState));
  const fetch_handlers = fetchHandlers(fetch_dispatch, fetch_state)

  const providerContext = () => <FetchContext.Provider
    value={{ fetch_state, fetch_handlers }}>
    {props.children}
  </FetchContext.Provider>

  return providerContext()
}

export default FetchProvider